<!-- container-xxl -->
<div class="content-wrapper p-0">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body">
		<section class="app-ecommerce-details">
			<!-- <div class="card"> -->
				<!-- <div class="card-body"> -->
					<div class="stepper-wrapper">
						<div class="stepper-item" [ngClass]="{ 'completed': stage.status }"
							*ngFor="let stage of stageData">
							<div class="step-counter">{{stage.id}}</div>
							<div class="step-name">{{stage.paraDescription}}</div>
						</div>
					</div>
					<div class="row">
						<div class="col-8">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Project Details</h5>
								</legend>
								<div class="row">
									<div class="col-5 text-wrap">
										<h3><b>{{form1_data?.principleInvestigator}}</b></h3>
										<span>{{form1_data?.subjectArea}}</span>
									</div>
									<div class="col-4">
										<div class="form-group row">
											<div class="col-5 col-form-label">
												<label><b>Email ID:</b></label>
											</div>
											<div class="col-7 col-form-label">
												<p class="text-justify">{{form1_data?.emailID}}</p>
											</div>
										</div>
										<div class="form-group row">
											<div class="col-5 col-form-label">
												<label><b>Mobile No.:</b></label>
											</div>
											<div class="col-7 col-form-label">
												<p class="text-justify">{{form1_data?.mobileNo}}</p>
											</div>
										</div>
									</div>
									<div class="col-3">
										<div class="form-group row">
											<div class="col-5 col-form-label">
												<label><b>Created Date:</b></label>
											</div>
											<div class="col-7 col-form-label">
												<p class="text-justify">{{form1_data?.createdAt}}</p>
											</div>
										</div>
										<div class="form-group row">
											<div class="col-5 col-form-label">
												<label><b>Modified Date:</b></label>
											</div>
											<div class="col-7 col-form-label">
												<p class="text-justify">{{form1_data?.modifiedAt}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Application No.:</b></label>
											</div>
											<div class="col-8 col-form-label">
												<p class="text-justify">{{form1_data?.applicationNumber}}</p><br />
											</div>
										</div>
									</div>
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Project Type:</b></label>
											</div>
											<div class="col-8 col-form-label">
												<p class="text-justify">{{form1_data?.projectType}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Project Title:</b></label>
											</div>
											<div class="col-8 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.projectTitle}}</p>
											</div>
										</div>
									</div>
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Principal Implementing Organization(s):</b></label>
											</div>
											<div class="col-8 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.principalImplementingOrganization}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label pr-0">
												<label><b>Duration (in Months):</b></label>
											</div>
											<div class="col-8 col-form-label pr-0">
												<p class="text-justify">{{form1_data?.duration}}</p>
											</div>
										</div>
									</div>
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label pr-0">
												<label><b>Share of implementing /participating Institutions in the total
														cost
														(Rs.):</b></label>
											</div>
											<div class="col-8 col-form-label">
												<p class="text-justify">{{form1_data?.shareImplementing}}</p>
											</div>
										</div>
									</div>
								</div>
							
								<div class="row">
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Category of Implementing Institution(s):</b></label>
											</div>
											<div class="col-8 col-form-label">
												<p class="text-justify">{{form1_data?.category_imp_institution}}</p>
											</div>
										</div>
									</div>
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Darpan Portal RegistrationID:</b></label>
											</div>
											<div class="col-8 col-form-label">
												<p class="text-justify">{{form1_data?.darpanPortlRegisterID}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Collaborating Organizations:</b></label>
											</div>
											<div class="col-8 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.collaboratingOrg}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-2 col-form-label">
												<label><b>Status of Work:</b></label>
											</div>
											<div class="col-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.statusOfWork}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-2 col-form-label">
												<label><b>Summary:</b></label>
											</div>
											<div class="col-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.summary}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-2 col-form-label">
												<label><b>Objectives:</b></label>
											</div>
											<div class="col-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.objectives}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-2 col-form-label">
												<label><b>Viability of Product:</b></label>
											</div>
											<div class="col-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.viabilityOfProduct}}</p>
											</div>
										</div>
									</div>
								</div>	
							</fieldset>
						</div>
						<div class="col-4">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Co-Principal Investigator(s)</h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
									<thead>
										<tr>
											<th>
												Name
											</th>
											<th>
												Contact No.
											</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of applicationDetail?.contactListArray; let $index=index">
											<td> {{item?.CoPrincipalInvestigator}}</td>
											<td> {{item?.CoPrincipalInvestigatorContactNo}}</td>
										</tr>
										<tr *ngIf="applicationDetail?.contactListArray.length == 0">
											<td colspan="2">No details are available.</td>
										</tr>
									</tbody>
								</table>
								</div>
							</fieldset>
							<br />

							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Cost Details</h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
									<thead>
										<tr>
											<th>
												Budget Details (Total Cost, MNRE Share,Industry Share)
											</th>
											<th>
												Amount (Rs.)
											</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of form1_data_Array">
											<td> {{item?.title}}</td>
											<td> {{item?.value}}</td>
										</tr>
										<tr *ngIf="form1_data_TotalCost">
											<td>Total Cost</td>
											<td>{{form1_data_TotalCost}}</td>
										</tr>
										<tr *ngIf="form1_data_Array.length == 0">
											<td colspan="2">No details are available.</td>
										</tr>
									</tbody>
								</table>
							</div>
							</fieldset>
							<br />
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Application Uploaded Documents</h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
									<thead>
										<tr>
											<th colspan="2">
												Download Document
											</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of documentList">
											<td> {{item?.keyName}}</td>
											<td>
												<a href="{{item?.applicantFile}}"
														target="_blank">
													<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i>
												</a>
											</td>
										</tr>
										<tr *ngIf="form1_data_Array.length == 0">
											<td colspan="2">No details are available.</td>
										</tr>
									</tbody>
								</table>
							</div>
							</fieldset>
							<br />
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Project Timeline</h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
									<thead>
										<tr>
											<th class="w-auto">Task</th>
											<th class="w-auto">Duration (in Months)</th>
										</tr>
									</thead>
									<tbody>
										<tr
											*ngFor="let item of applicationDetail?.application_timeline; let $index=index">
											<td class="text-justify" >
												<span>{{item?.name}}</span>
											</td>
											<td>
												<span>{{item?.duration}}</span>
											</td>
										</tr>
										<tr *ngIf="applicationDetail?.application_timeline.length == 0">
											<td colspan="2">No details are available.</td>
										</tr>
									</tbody>
								</table>
								</div>
							</fieldset>
						</div>
					</div>

					<div class="row">
						<div class="form-group col-12">
							<!-- <h4>Proposal Format - 2</h4> -->
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Proposed cost</h5>
								</legend>
								<div class="table-responsive table-bordered">
									<table class="table mb-0">
										<thead>
											<tr>
												<th scope="col" class="text-wrap" rowspan="2">Proposed cost: (Details of
													equipment along
													with justification to be provided separately in the Format as per
													Annexure
													I)</th>
												<th scope="col" class="text-wrap" rowspan="2">SR. No.</th>
												<th scope="col" class="text-wrap" rowspan="2">Item</th>
												<th scope="col" class="text-wrap"  rowspan="2">
													Total Cost
												</th>
												<th scope="col" class="text-wrap" style="text-align: center;"
												[attr.colspan]="noOfYeararray.length">
													Amount (Rs.)
												</th>
											</tr>
											<tr>
												<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
													{{y.key}}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of proposedCostArray; let $index=index">
												<td *ngIf="$index==0" [attr.rowspan]="proposedCostArray.length"></td>
												<td scope="col" class="text-wrap">{{$index + 1}}.</td>
												<td scope="col" class="text-wrap">
													<span>{{item?.proposedCostItemName}}</span>
												</td>
												<td scope="col" class="text-wrap">
													<span>{{item?.totalCost}}</span>
												</td>
												<td scope="col" class="text-wrap" *ngFor="let y of item?.years; let $index1 = index1">
													<span>{{y.value}}</span>
												</td>
											</tr>
											<tr>
												<td style="border-top: none;"></td>
												<td scope="col" class="text-wrap">Total</td>
												<td scope="col" class="text-wrap"></td>
												<td scope="col" class="text-wrap">
													<span>{{total}}</span>
												</td>
												<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray">
													<span>{{y.proposedCostTotal}}</span>
												</td>
											</tr>
										</tbody>
									</table>
									<table class="table">
										<tbody>
											<tr>
												<td scope="col" class="text-wrap">Project Deliverables
													(products/process/papers/IPR)</td>
												<td scope="col" class="text-justify" colspan="2">
													<span>{{form2_other_data?.projectDeliverables}}</span>
												</td>
											</tr>
											<!-- <tr>
												<td>Timelines (in terms of Work Plan)</td>
												<td scope="col" class="text-wrap" colspan="2">
													<span>{{form2_other_data?.timelines}}</span>
												</td>
											</tr> -->
											<tr>
												<td scope="col" class="text-wrap">Potential Users and suggested Plan of
													action
													for
													utilization of expected Project Output with proper analysis for
													scalability
													and
													bankability</td>
												<td scope="col" class="text-justify" colspan="2">
													<span>{{form2_other_data?.scalabilityAndBankability}}</span>
												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap" colspan="3"><b>Other Information</b>
												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">Certificate from the Principal
													Investigator
													and Grantee
													organization</td>
												<td class="text-justify">
													<span>{{form2_other_data?.investigatorGranteeOrg}}</span>
												</td>
												<td *ngIf="(form2_other_data?.investigatorGranteeOrgFile != '')">
													<a href="{{form2_other_data?.investigatorGranteeOrgFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">
													Infrastructural facilities available at the host institution (e.g.
													telecommunication,
													Internet, Electrical/ Mechanical Workshop, Laboratoryspace, power
													supply
													including back
													up
													arrangement,etc.)
												</td>
												<td class="text-justify">
													<span>{{form2_other_data?.hostInstitution}}</span>
												</td>
												<td *ngIf="(form2_other_data?.hostInstitutionFile != '')">
													<a href="{{form2_other_data?.hostInstitutionFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>

												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">
													CVs of PI and all co PIs, which would include details of other R&D
													projects
													implemented,
													their cost, status (completed/ under implementation) and sponsors.
												</td>
												<td class="text-justify">
													<span>{{form2_other_data?.costStatus}}</span>
												</td>
												<td *ngIf="(form2_other_data?.costStatusFile != '')">
													<a href="{{form2_other_data?.costStatusFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">
													<span>Details of Research Methodology</span>
												</td>
												<td>
												</td>
												<td *ngIf="(form2_other_data?.researchMethodologyFile != '')">
													<a href="{{form2_other_data?.researchMethodologyFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</fieldset>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-12">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Cost of Equipment</h5>
								</legend>
								<div class="table-responsive table-bordered">
									<table class="table table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col" class="text-wrap">Sr. No.</th>
												<th scope="col" class="text-wrap">Name of the Equipment along with make
													&
													model</th>
												<th scope="col" class="text-wrap">Imported/ Indigenous</th>
												<th scope="col" class="text-wrap">Estimated Costs (in INR Currency
													also
													for imported
													equipment)*</th>
												<th scope="col" class="text-wrap">Justification</th>
												<th scope="col" class="text-wrap"></th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of form3coeArray; let $index=index">
												<td scope="col" class="text-wrap">{{$index + 1}}.</td>
												<td class="text-justify">
													<span>{{item?.makeAndModel}}</span>
												</td>
												<td class="text-justify">
													<span>{{item?.importedIndgenous}}</span>
												</td>
												<td class="text-justify">
													<span>{{item?.estimatedCost}}</span>
												</td>
												<td class="text-justify">
													<span>{{item?.justification}}</span>
												</td>
												<td scope="col" class="text-wrap"
													*ngIf="(item?.transportInsuranceInstallationChargesFile != '')">
													<a href="{{item?.transportInsuranceInstallationChargesFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>
											<tr *ngIf="form3coeArray.length == 0">
												<td colspan="6">No details are available.</td>
											</tr>
										</tbody>
									</table>
								</div>
								<span>*Including transport, insurance and installation charges.</span>
							</fieldset>
						</div>
					</div>

					<div class="row">
						<div class="form-group col-12">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Manpower Cost</h5>
								</legend>
								<div class="table-responsive table-bordered">
									<table class="table table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col" class="text-wrap" rowspan="2">Sr. No.</th>
												<th scope="col" class="text-wrap" rowspan="2">Designation/ Numbers</th>
												<th scope="col" class="text-wrap" rowspan="2">Justification</th>
												<th scope="col" class="text-wrap" rowspan="2">Monthly Salary</th>
												<th scope="col" class="text-wrap" style="text-align: center;"
												[attr.colspan]="dynamicColumnCount">Amount (Rs.)
												</th>
												<!-- <th scope="col" class="text-wrap" rowspan="2"></th> -->
											</tr>
											<tr>
												<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
													{{y.key}}
												</th>
												<th scope="col" class="text-wrap">Total</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of manpowerDetailArray; let $index=index">

												<td scope="col" class="text-wrap">{{$index + 1}}.</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.designation}}
												</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.justification}}
												</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.monthlyEmoluments}}
												</td>
												<td scope="col" class="text-wrap" *ngFor="let y of item?.years; let $index1 = index1">
													<span>{{y.value}}</span>
												</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.total}}
												</td>
											</tr>
											<tr *ngIf="manpowerDetailArray?.length == 0">
												<td [attr.colspan]="dynamicColumnCount">No details are available.</td>
											</tr>
										</tbody>
									</table>
								</div>
								<!-- <span>*Man months to be given within brackets before the budget amount.</span> -->
							</fieldset>
						</div>
					</div>

					<div class="row">
						<div class="form-group col-12">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Cost of Consumables</h5>
								</legend>
								<div class="table-responsive table-bordered">
									<table class="table table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col" class="text-wrap" rowspan="2">Sr. No.</th>
												<th scope="col" class="text-wrap" rowspan="2">Item</th>
												<th scope="col" class="text-wrap" rowspan="2">Quantity</th>
												<th scope="col" class="text-wrap" rowspan="2">Unit</th>
												<th scope="col" class="text-wrap" style="text-align: center;"
												[attr.colspan]="noOfYeararray.length">
													Amount (Rs.)
												</th>
											</tr>
											<tr>
												<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
													{{y.key}}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of costOfConsumableArray; let $index=index">
												<td scope="col" class="text-justify">{{$index + 1}}.</td>
												<td scope="col" class="text-justify">{{item?.item}}</td>
												<td scope="col" class="text-justify">{{item?.qty}}</td>
												<td scope="col" class="text-justify">{{item?.unitName}}</td>
												<td scope="col" class="text-justify" *ngFor="let y of item?.years; let $index1 = index1">
													<span>{{y.value}}</span>
												</td>
											</tr>
											<tr *ngIf="costOfConsumableArray?.length > 0">
												<td
													scope="col"
													colspan="4"
													class="text-wrap"
													style="text-align: right"
												>
													Total:
												</td>
												<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray">
													<span>{{y.costofConsumableTotal}}</span>
												</td>
											</tr>
											<tr *ngIf="costOfConsumableArray?.length == 0">
												<td [attr.colspan]="dynamicColumnCount">No details are available.</td>
											</tr>
										</tbody>
										
									</table>
								</div>
							</fieldset>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-12">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Travel Cost</h5>
								</legend>
								<div class="table-responsive table-bordered">
									<table class="table table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col" class="text-wrap" rowspan="2">Sr. No.</th>
												<th scope="col" class="text-wrap" rowspan="2">Travel (Domestic/International)</th>
												<th scope="col" class="text-wrap" rowspan="2">Justification</th>
												<th scope="col" class="text-wrap" style="text-align: center;" [attr.colspan]="dynamicColumnCount">
													Amount (Rs.)
												</th>
											</tr>
											<tr>
												<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
													{{y.key}} (m. m.*)
												</th>
												<th scope="col" class="text-wrap">Total</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of travelCostArray; let $index=index">
												<td scope="col" class="text-wrap">{{$index + 1}}.</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.title}}
												</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.justification}}
												</td>
												<td scope="col" class="text-wrap" *ngFor="let y of item?.years; let $index1 = index1">
													<span>{{y.value}}</span>
												</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.total}}
												</td>
											</tr>
											<tr *ngIf="travelCostArray?.length == 0">
												<td [attr.colspan]="dynamicColumnCount">No details are available.</td>
											</tr>
										</tbody>
									</table>
								</div>
							</fieldset>
						</div>
					</div>

					<div class="row">
						<div class="form-group col-4">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Expert Comments</h5>
								</legend>
								<table class="table table-striped table-bordered">
									<thead>
										<tr>
											<th>
												Expert Name
											</th>
											<th>
												Rating
											</th>
											<th *ngIf="!this.isUser">
												Download
											</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let exp of expertList">
											<td class="text-justify"> <a href="Javascript:void(0)"
													(click)="viewComment(modalExpertEvalution, exp?.id)"><span>{{exp?.name}}</span></a></td>
											<td class="text-justify"> {{exp?.totalRating}}/100</td>
											<td class="text-justify"   *ngIf="exp.expertCommentsUrl && !this.isUser" > 
												<a href="{{exp?.expertCommentsUrl}}" target="_blank">
													<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
														title="Download"></i>
												</a>
											</td>
										</tr>
										<tr *ngIf="expertList.length == 0">
											<td colspan="2">No details are available.</td>
										</tr>
									</tbody>
								</table>
							</fieldset>
						</div>
						<div class="form-group" [ngClass]="!this.isUser ? 'col-8' : 'col-12'">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Review Report</h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
									<thead>
										<tr>
											<th> Stage </th>
											<th> Submission Date </th>
											<th> Status </th>
											<th> Action Date </th>
											<th> Download </th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of reviewList">
											<td>
												<a href="Javascript:void(0)"
													(click)="progressReportDetails(modalPR,item.progressReportId)"><span>{{item?.reviewReportCount}}</span></a>
											</td>
											<td class="text-justify"> {{item?.submitionDate}}</td>
											<td class="text-justify"> {{item?.progressReportStatus}}</td>
											<td class="text-justify"> {{item?.statusDate}}</td>
											<td class="text-justify"> <a href="{{item?.reviewReportUrl}}" target="_blank">
													<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
														title="Download"></i>
												</a></td>
										</tr>
										<tr *ngIf="reviewList.length == 0">
											<td colspan="5">No details are available.</td>
										</tr>
									</tbody>
								</table>
							</div>
							</fieldset>
						</div>
						<div class="form-group col-4" *ngIf="stageData[5]?.status || stageData[2]?.status">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;"></h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
									<thead>
										<tr>
											<th> Details </th>
											<th> Download </th>
										</tr>
										<tr *ngIf="stageData[5]?.status">
											<td class="text-justify">
												<a href="Javascript:void(0)"
													(click)="completionReportDetails(modalCR)"><span>Completion Report Details</span></a>
											</td>
											<td>
												<div *ngIf="documentUrl">
													<a href="{{documentUrl}}" target="_blank">
														<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download"></i>
													</a>
												</div>
											</td>
										</tr>
										<tr *ngIf="stageData[2]?.status">
											<td class="text-justify">
												<a href="Javascript:void(0)"
													(click)="mandateDetailsModel(modalBM)"><span>Bank Mandate
														Details</span></a>
											</td>
											<td>
												<div *ngIf="mandateFormURL">
													<a href="{{mandateFormURL}}" target="_blank">
														<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download"></i>
													</a>
												</div>
											</td>
										</tr>
									</thead>
								</table>
							</div>
							</fieldset>
						</div>
					</div>
				<!-- </div> -->
			<!-- </div> -->
		</section>
	</div>

	<div class="scrolling-content-inside-modal">
		<ng-template #modalExpertEvalution let-modal>
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalCenterTitle">Expert Evaluation</h5>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" tabindex="0" ngbAutofocus>
				<form [formGroup]="format4" *ngIf="format4" autocomplete="off">
					<div class="row">
						<div class="form-group col-12" style="text-align: right;">
							<span><b><u>Annexure-III</u></b></span>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-12" style="text-align: center;">
							<span><b>Ministry of New and Renewable Energy</b></span>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-12" style="text-align: center;">
							<span><b><u>Proforma for preparation of Expert Comments on R&D/ Technology Development
										Projects</u></b></span>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-12">
							<span><b>Project Title:</b> {{form1_data?.projectTitle}}</span>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-12">
							<span><b>MNRE Reference:</b></span>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-12">
							<div class="table-responsive table-bordered">
								<table class="table mb-0 table-striped table-bordered">
									<thead>
										<tr>
											<th width="5%" scope="col" class="text-wrap">Sr. No.</th>
											<th width="40%" scope="col" class="text-wrap">Item</th>
											<th width="40%" scope="col" class="text-wrap">Comments of Expert</th>
											<th width="15%" scope="col" class="text-wrap">Rating by Expert/
												max. rating</th>
										</tr>
									</thead>
									<tbody>
										<tr
											*ngFor="let item of format4.controls.expertEvalutionArray.controls; let $index=index">
											<td style="text-align: center;">{{$index + 1}}</td>
											<td scope="col" class="text-wrap">
												{{item.value.parentPara}}
												<ul
													*ngFor="let childItem of item.value.childPara; let $childIndex=index">
													<li class="text-wrap">
														{{childItem.paraDescription}}
													</li>
												</ul>
											</td>
											<td scope="col" class="text-wrap text-justify">
												<span>{{item.value.comments}}</span>
											</td>
											<td scope="col" class="text-wrap text-justify">
												<span style="float: right;"
													*ngIf="item.value.rating > 0">{{item.value.givenRating}}/{{item.value.rating}}</span>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-md-12">
							<div class="row">
								<div class="col-md-2" *ngIf="format4.controls.EvalutionDocument.value">
									Download Document
									<a href="{{format4.controls.EvalutionDocument.value}}" target="_blank">
										<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download"></i>
									</a>
								</div>
								<div class="col-md-10">
									<label class="form-label" for="remarks">Remarks :
										{{format4.controls.Remarks.value}}</label>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</ng-template>
	</div>

	<ng-template #modalPR let-modal>
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalCenterTitle">Approve/Reject Progress Report
			</h5>
			<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body" tabindex="0" ngbAutofocus>
			<form [formGroup]="progreeReportDetailsForm" autocomplete="off">
				<div class="row">
					<div class="form-group col-4">
						<span><b>Project Title:</b> {{progreeReportDetailsForm.get("projectTitle").value}}
						</span>

					</div>
					<div class="form-group col-4">
						<span><b>Sanction Order No.:</b> {{sanctionDetails?.orderNo}}</span>
					</div>
					<div class="form-group col-4">
						<span><b>Sanction Order Date:</b> {{sanctionDetails?.sanctionDate}}</span>
					</div>
				</div>

				<div class="row">
					<div class="form-group col-4">
						<span><b>Released order No.:</b> {{releasedOrderNo}}
						</span>
					</div>
					<div class="form-group col-4">
						<span><b>Released Date:</b> {{releasedDate}}</span>
					</div>
					<div class="form-group col-4">
						<span><b>Released Amount:</b> {{releasedAmount}}</span>
					</div>
				</div>

				<div class="row">
					<div class="form-group col-4">
						<span><b>Name of PI:</b> {{progreeReportDetailsForm.get("NameOfPI").value}}</span>
					</div>
					<div class="form-group col-4 text-justify">
						<span><b>Complete Address of PI:</b>
							{{progreeReportDetailsForm.get("AddressOfPI").value}}</span>
					</div>
					<div class="form-group col-4">
						<span><b>Project Start Date:</b> {{sanctionDetails?.createdDate}}</span>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-3">
						<span><b>Project End Date:</b> {{sanctionDetails?.endDate}}</span>
					</div>
					<div class="form-group col-3">
						<span><b>Approved project budget:</b> {{sanctionDetails?.amount}}</span>
					</div>
					<div class="form-group col-3">
						<span><b>Download Other Document:</b></span>
						<div *ngIf="progreeReportDetailsForm.get('otherDocument').value" class="download-file"
							style="width: 50%; float: right;">
							<a href="{{progreeReportDetailsForm.get('otherDocument').value}}"
								target="_blank"><i
									class="custom-control-inline feather avatar-icon font-medium-1 icon-arrow-down-circle"
									title="Download Document"></i></a>
						</div>
					</div>
					<div class="form-group col-3">
						<span><b>Download Technical Report:</b> </span>
						<div *ngIf="progreeReportDetailsForm.get('technicalReport').value" class="download-file"
							style="width: 50%; float: right;">
							<a href="{{progreeReportDetailsForm.get('technicalReport').value}}"
								target="_blank"><i
									class="custom-control-inline feather avatar-icon font-medium-1 icon-arrow-down-circle"
									title="Download Document"></i></a>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-12">
						<fieldset class="border" style="padding: 0.7rem;">
							<legend class="w-auto">
								<h5 style="margin-top: 7px;"></h5>
							</legend>
							<div class="row">
								<div class="form-group col-6 text-justify">
									<span class="text-justify"><b>Actual expenditure as on date enclosing SoE and UC:</b>
										{{progreeReportDetailsForm.get("actualExpenditure").value}}</span>
								</div>
								<div class="form-group col-6 text-justify">
									<span class="text-justify"><b>Approved Objectives of the Project:</b>
										{{progreeReportDetailsForm.get("approvedObjectivesProject").value}}</span>
								</div>
							</div>
							<div class="row">
								<div class="form-group col-6 text-justify">
									<span class="text-justify"><b>Output of the approved Project:</b>
										{{progreeReportDetailsForm.get("outputApprovedProject").value}}</span>
								</div>
								<div class="form-group col-6 text-justify">
									<span class="text-justify"><b>Summary of the Progress reported:</b>
										{{progreeReportDetailsForm.get("summaryProgressReported").value}}</span>
								</div>
							</div>
							<div class="row">
								<div class="form-group col-6 text-justify">
									<span><b>Detailed Progress:</b>
										{{progreeReportDetailsForm.get("detailedProgress").value}}</span>
								</div>
							</div>
						</fieldset>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-12">
						<fieldset class="border" style="padding: 0.7rem;">
							<legend class="w-auto">
								<h5 style="margin-top: 7px;"></h5>
							</legend>
							<div class="row">
								<div class="form-group col-4 text-justify">
									<span class="text-justify"><b>New Observations:</b>
										{{progreeReportDetailsForm.get("newObservations").value}}</span>
								</div>
								<div class="form-group col-4 text-justify">
									<span class="text-justify"><b>Innovations:</b>
										{{progreeReportDetailsForm.get("innovations").value}}</span>
								</div>
								<div class="form-group col-4 text-justify">
									<span class="text-justify"><b>Application Potential:</b>
										{{progreeReportDetailsForm.get("applicationPotential").value}}</span>
								</div>
							</div>
							<div class="row">
								<div class="form-group col-12 text-justify">
									<span class="text-justify"><b>Research / Technology development work remaining to be done under the
											project and Work Plan for next six months:</b>
										{{progreeReportDetailsForm.get("projectAndWorkPlan").value}}</span>
								</div>
							</div>
						</fieldset>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-12">
						<fieldset class="border" style="padding: 0.7rem;">
							<legend class="w-auto">
								<h5 style="margin-top: 7px;">Financial Progress Report</h5>
							</legend>
							<div class="row">
								<div class="form-group col-6 text-justify">
									<span class="text-justify"><b>Status of Financial yearwise UC and SoE:</b>
										{{progreeReportDetailsForm.get("statusFinancialYearwise").value}}</span>
								</div>
								<div class="form-group col-3">
									<span class="text-justify"><b>Download UC letter:</b></span>
									<div *ngIf="progreeReportDetailsForm.get('UCletter').value" class="download-file"
										style="width: 50%; float: right;">
										<a href="{{progreeReportDetailsForm.get('UCletter').value}}"
											target="_blank"><i
												class="custom-control-inline feather avatar-icon font-medium-1 icon-arrow-down-circle"
												title="Download Document"></i></a>
									</div>
								</div>
								<div class="form-group col-3">
									<span class="text-justify"><b>Download SOE letter:</b> </span>
									<div *ngIf="progreeReportDetailsForm.get('SOEletter').value" class="download-file"
										style="width: 50%; float: right;">
										<a href="{{progreeReportDetailsForm.get('SOEletter').value}}"
											target="_blank"><i
												class="custom-control-inline feather avatar-icon font-medium-1 icon-arrow-down-circle"
												title="Download Document"></i></a>
									</div>
								</div>
							</div>
						</fieldset>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-6">
						<fieldset class="border" style="padding: 0.7rem;">
							<legend class="w-auto">
								<h5 style="margin-top: 7px;">Total funds released by MNRE</h5>
							</legend>
							<table class="table table-responsive table-striped table-bordered">
								<thead>
									<tr>
										<th>Sanction No.</th>
										<th>Date</th>
										<th>Amount (Rs.)</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="text-justify">{{sanctionDetails?.orderNo}}</td>
										<td class="text-justify">{{sanctionDetails?.sanctionDate}}</td>
										<td class="text-justify">{{sanctionDetails?.amount}}</td>
									</tr>
								</tbody>
							</table>
						</fieldset>
					</div>
					<div class="form-group col-6">
						<fieldset class="border" style="padding: 0.7rem;">
							<legend class="w-auto">
								<h5 style="margin-top: 7px;">Status of Manpower</h5>
							</legend>
							<table class="table table-responsive table-striped table-bordered">
								<thead>
									<tr>
										<th>SANCTIONED LIST</th>
										<th>IN POSITION (YES/ NO)</th>
										<th>SCALE</th>
										<th>REMARKS (GIVE REASONS FOR NEGATIVE RESPONSE)</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let item of manpowerArray; let $index=index">
										<td class="text-justify">{{item.sanctionList}}</td>
										<td class="text-justify">{{item.inPosition}}</td>
										<td class="text-justify">{{item.scale}}</td>
										<td class="text-justify">{{item.remarks}}</td>
									</tr>
									<tr *ngIf="manpowerArray?.length == 0">
										<td colspan="4">No details are available.</td>
									</tr>
								</tbody>
							</table>
						</fieldset>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-12">
						<fieldset class="border" style="padding: 0.7rem;">
							<legend class="w-auto">
								<h5 style="margin-top: 7px;">Status of Equipment Procurement</h5>
							</legend>
							<table class="table table-responsive table-striped table-bordered">
								<thead>
									<tr>
										<th>SANCTIONED ITEMS OF EQUIPMENT</th>
										<th>PROCUREMENT STATUS (YES/ NO) MODEL & MAKE, DATE OF PROCUREMENT &
											COMMISSIONING</th>
										<th>COST (RS)</th>
										<th>WORKING (YES/ NO)</th>
										<th>REMARKS (GIVE REASONS FOR NEGATIVE RESPONSE)</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let item of prEquipmentDetailsArray; let $index=index">
										<td class="text-justify">{{item.sanctionItemsOfEquipment}}</td>
										<td class="text-justify">{{item.procurementStatus}}</td>
										<td class="text-justify">{{item.equipmentCost}}</td>
										<td class="text-justify">{{item.workingStatus}}</td>
										<td class="text-justify">{{item.remarks}}</td>
									</tr>
									<tr *ngIf="prEquipmentDetailsArray == 0 ">
										<td colspan="5">No details are available.</td>
									</tr>
								</tbody>
							</table>
						</fieldset>
					</div>
				</div>
			</form>
		</div>

	</ng-template>
	<ng-template #modalCR let-modal>
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalCenterTitle">Completion Report Details</h5>
			<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body" tabindex="0" ngbAutofocus>
			<div class="row">
				<div class="col-4 form-group text-justify text-wrap">
					<span class="font-bold">Principal Investigator(s) : </span><span>{{reportDetails
						?.principleInvestigator}}</span>
					<span></span>
				</div>
			</div>
			<div class="row">
				<div class="col-4 form-group text-justify text-wrap">
					<span class="font-bold">Date of Commencement of Project : </span><span>{{reportDetails?.createdDate}}</span>
					<span></span>
				</div>
				<div class="col-4 form-group text-justify text-wrap">
					<span class="font-bold">Actual date of Completion : </span><span>{{reportDetails?.endDate}}</span>
					<span></span>
				</div>
				<div class="col-4 form-group text-justify text-wrap">
					<span class="font-bold">Approved date of completion : </span><span>{{reportDetails?.approvedDateOfCompletion}}</span>
					<span></span>
				</div>
			</div>
			<div class="row">
				<div class="col-6 form-group text-justify text-wrap">
					<span class="font-bold">Implementing Institution(s) : </span><span>{{reportDetails?.principalImplementingOrganization}}</span>
					<span></span>
				</div>
				<div class="col-6 form-group text-justify text-wrap">
					<span class="font-bold">Collaborating Institution(s) : </span><span>{{reportDetails?.collaboratingOrg}}</span>
					<span></span>
				</div>
			</div>
			
			<div class="row">
				<div class="col-6 form-group text-justify text-wrap">
					<span class="font-bold">Objectives of the Project : </span><span>{{reportDetails?.objectives}}</span>
					<span></span>
				</div>
				<div class="col-6 form-group text-justify text-wrap">
					<span class="font-bold">Patents Taken : </span><span>{{reportDetails?.patentsTaken}}</span>
					<span></span>
				</div>
			</div>
			<div class="row">
				<div class="col-12 form-group text-justify text-wrap">
					<span class="font-bold">Output of the Project : </span><span>{{reportDetails?.outPutOftheProject}}</span>
					<span></span>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-12">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">S&T Benefits Accrued</h5>
						</legend>
						<table class="table table-striped table-bordered">
							<thead>
								<tr>
									<th>No.</th>
									<th>AUTHORS</th>
									<th>TITLE OF PAPER</th>
									<th>NAME OF THE JOURNAL</th>
									<th>VOLUME</th>
									<th>PAGES</th>
									<th>YEAR</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let item of STbenefitsDetails; let $index=index">
									<td>{{$index+1}}</td>
									<td class="text-justify text-wrap">{{item.authors}}</td>
									<td class="text-justify text-wrap">{{item.titleOfPaper}}</td>
									<td>{{item.nameOfJournal}}</td>
									<td>{{item.volume}}</td>
									<td>{{item.pages}}</td>
									<td>{{item.year}}</td>
								</tr>
								<tr *ngIf="STbenefitsDetails?.length == 0">
									<td colspan="7" style="text-align: center;">No details are available.</td>
								</tr>
							</tbody>
						</table>
					</fieldset>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-6">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">Download Documents</h5>
						</legend>
						<table class="table table-striped table-bordered">
							<thead>
								<tr>
									<th>No.</th>
									<th>Remarks</th>
									<th>Download</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let item of documentDowload; let $index=index">
									<td>{{$index+1}}</td>
									<td class="text-justify text-wrap">{{item.remarks}}</td>
									<td>
										<a href="{{item.documentUrl}}" target="_blank"><i
												class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
												title="Download Document"></i></a>
									</td>
								</tr>
								<tr *ngIf="documentDowload.length == 0">
									<td colspan="3" style="text-align: center;">No details are available.</td>
								</tr>
							</tbody>
						</table>
					</fieldset>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-12">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">Manpower trained Under the Project</h5>
						</legend>
						<div class="row">
							<div class="col-6 form-group text-justify text-wrap">
								<span class="font-bold">Research Scientists/ Research Associates :
								</span><span>{{reportDetails
									?.researchScientistsAssociates}}</span>
								<span></span>
							</div>
							<div class="col-6 form-group text-justify text-wrap">
								<span class="font-bold">No. of Ph.D. (s) Produced : </span><span>{{reportDetails
									?.NoOfPhDproduced}}</span>
								<span></span>
							</div>
						</div>
						<div class="row">
							<div class="col-6 form-group text-justify text-wrap">
								<span class="font-bold">Other Technical Personnel Trained : </span><span>{{reportDetails
									?.technicalPersonnelTrained}}</span>
								<span></span>
							</div>
							<div class="col-6 form-group text-justify text-wrap">
								<span class="font-bold">Awareness, Training Camps, etc. Organized :
								</span><span>{{reportDetails
									?.awarenessTrainingCampsOrganized}}</span>
								<span></span>
							</div>
						</div>
						<div class="row">
							<div class="col-6 form-group text-justify text-wrap">
								<span class="font-bold">Details of work which could not be Completed ( if any) :
								</span><span>{{reportDetails
									?.detailsOfWork}}</span>
								<span></span>
							</div>
							<div class="col-6 form-group text-justify text-wrap">
								<span class="font-bold">Suggestions on Further Work on the Subject of Research :
								</span><span>{{reportDetails
									?.suggestionsOnFurtherWork}}</span>
								<span></span>
							</div>
						</div>
					</fieldset>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-12">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">Project Expenditure</h5>
						</legend>
						<table class="table table-striped table-bordered">
							<thead>
								<tr>
									<th>No.</th>
									<th>Financial Position/ Budget Head</th>
									<th>Amount Sanctioned</th>
									<th>Actual Expenditure</th>
									<th>Deviation if any</th>
									<th>% of Total cost</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let item of projectExpenditure; let $index=index">
									<td>{{ $index+1}}</td>
									<td>{{ item.paraDescription }}</td>
									<td>{{ item.amountSanctioned}}</td>
									<td>{{ item.actualExpenditure }}</td>
									<td>{{ item.deviation}}</td>
									<td>{{ item.totalCost }}</td>
								</tr>
								<tr *ngIf="projectExpenditure ?.length > 0">
									<td></td>
									<td>Total</td>
									<td>{{ projectExpenditureTotal ?. totalAmountSanctioned }}</td>
									<td>{{ projectExpenditureTotal ?. totalExpenditure }}</td>
									<td>{{ projectExpenditureTotal ?. totalDeviation }}</td>
									<td>{{ projectExpenditureTotal ?. grandTotalCost }}</td>
								</tr>
								<tr *ngIf="projectExpenditure ?.length == 0">
									<td colspan="6" style="text-align: center;">No details are available.</td>
								</tr>
							</tbody>
						</table>
					</fieldset>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-12">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">Equipment Status</h5>
						</legend>
						<table class="table table-striped table-bordered">
							<thead>
								<tr>
									<th>No.</th>
									<th>NAME OF EQUIPMENT</th>
									<th>YEAR OF PURCHASE</th>
									<th>MAKE/ MODEL</th>
									<th>COST (FE/ RS)</th>
									<th>DATE OF INSTALLATION</th>
									<th>UTILIZATION RATE (%)</th>
									<th>REMARKS REGARDING MAINTENANCE/ BREAKDOWN</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let item of equipmentDetails; let $index=index">
									<td>{{$index+1}}</td>
									<td class="text-justify text-wrap">{{item.nameOfEquipment}}</td>
									<td>{{item.yearOfPurchase}}</td>
									<td>{{item.makeModel}}</td>
									<td>{{item.costOfInstallation}}</td>
									<td>{{item.dateOfInstallation}}</td>
									<td>{{item.rate}}</td>
									<td class="text-justify text-wrap">{{item.remarks}}</td>
								</tr>
								<tr *ngIf="equipmentDetails.length == 0">
									<td colspan="8" style="text-align: center;">No details are available.</td>
								</tr>
							</tbody>
						</table>
					</fieldset>
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template #modalBM let-modal>
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalCenterTitle">Bank Mandate Details</h5>
			<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body" tabindex="0" ngbAutofocus>
			<div class="row">
				<div class="form-group col-12">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">Details of Account Holder</h5>
						</legend>
						<div class="row">
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Name of the Account Holder : </span><span class="text-wrap">{{mandateDetails
									?.accountHolderName}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Complete Contact Address : </span><span class="text-wrap">{{mandateDetails
									?.completeAddress}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Telephone No. : </span><span class="text-wrap">{{mandateDetails
									?.telephoneNo}}</span>
								<span></span>
							</div>
						</div>
						<div class="row">
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Fax No : </span><span class="text-wrap">{{mandateDetails
									?.faxNo}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Email : </span><span class="text-wrap">{{mandateDetails
									?.email}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Pan No. : </span><span class="text-wrap">{{mandateDetails
									?.pan}}</span>
								<span></span>
							</div>
						</div>
						<div class="row">
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Tin : </span><span class="text-wrap">{{mandateDetails.isTinApplicable == 1
									? "Applicable" : "Not Applicable"}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Tin Number : </span><span class="text-wrap">{{mandateDetails
									?.tinNumber}}</span>
								<span></span>
							</div>
						</div>
					</fieldset>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-12">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">Bank Account Details</h5>
						</legend>
						<div class="row">
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Name of the Bank : </span><span>{{mandateDetails
									?.nameOfBank}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Name and Address of the Bank/Branch :
								</span><span>{{mandateDetails
									?.addressOfBank}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Complete Bank Account Number : </span><span>{{mandateDetails
									?.completeAccountNumber}}</span>
								<span></span>
							</div>
						</div>
						<div class="row">
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Emai ID : </span><span>{{mandateDetails
									?.bankEmail}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Name of the Beneficiary : </span><span>{{mandateDetails
									?.nameOfBeneficiary}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">IFSC code : </span><span>{{mandateDetails
									?.ifscCode}}</span>
								<span></span>
							</div>
						</div>
						<div class="row">
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">MICR code : </span><span>{{mandateDetails
									?.micrCode}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">IBAN Account Number : </span><span>{{mandateDetails
									?.ibanAccountNumber}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Telephone No. : </span><span>{{mandateDetails
									?.bankTelephoneNo}}</span>
								<span></span>
							</div>
						</div>
						<div class="row">
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">BIC/Swift Code : </span><span>{{mandateDetails
									?.bicSwiftCode}}</span>
								<span></span>
							</div>
							<div class="col-4 form-group text-justify text-wrap">
								<span class="font-bold">Type of Bank Account : </span><span>{{mandateDetails
									?.typeOfBankAccount}}</span>
								<span></span>
							</div>
						</div>
						<div class="row p-2">
							<table class="table table-responsive table-striped table-bordered">
								<tr *ngIF="mandateDetails.chequeDocumentUrl">
									<td>Download Cancel Cheque</td>
									<td>
										<a href="{{mandateDetails?.chequeDocumentUrl}}" target="_blank"><i
												class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
												title="Download Document"></i></a>
									</td>
								</tr>
								<tr *ngIF="mandateDetails.bondDocumentUrl">
									<td>Download Boand</td>
									<td>
										<a href="{{mandateDetails?.bondDocumentUrl}}" target="_blank"><i
												class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
												title="Download Document"></i></a>
									</td>
								</tr>
								<tr *ngIF="mandateDetails.signedMandateUrl">
									<td>Download uploaded Mandare Form</td>
									<td>
										<a href="{{mandateDetails?.signedMandateUrl}}" target="_blank"><i
												class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
												title="Download Document"></i></a>
									</td>
								</tr>
							</table>
						</div>
					</fieldset>
				</div>
			</div>
		</div>
	</ng-template>
</div>